import React, {Component} from 'react'
import { withStyles } from '@material-ui/core/styles'
import { Grid} from '@material-ui/core'
import styles from './styles'
import {contentData} from './content'

import BasicView from '../../../../components/Layouts/BasicView/BasicView'
import FormA from '../../../../components/Forms/FormA/FormA'

import {
  sleep,
  request_employees,
  request_add_business
} from './requests'

import {formData as prospectdata} from './prospectdata/data' 
import {contentData as prospectcontent} from './prospectdata/content' 
import {catalog_matrix as prospectmatrix} from './prospectdata/catalog_matrix'


class AddBusiness extends Component{

  state = {
    isloading:false,
    users:[],
    forms:{
      prospectinfo:{issending:false, error:null},
    },
    success:{open:false,timeout:2000,type:'success',message:'Successful action!'},
  }

  componentDidMount(){
    console.log(this.props.match.params.id)
    this.initModule()
  }

  onCloseSnackbar = (id) => {
    let temp = this.state[id];
    temp.open = false;
    this.setState({[id]:{...temp}})
  }

  onGetPageID = () => {
    const {history} = this.props
    const path = history.location.pathname
    return path.substring(path.lastIndexOf('/')+1)
  }

  onActivateSuccessSnack = () => {
    const {success} = this.state;
    let success_temp = {...success};
    success_temp.open = true;
    this.setState({success:{...success_temp}})
  }

  initModule = async() => {
    this.setState({isloading:true})
    let response = await request_employees()
    this.setState({users:[...response]})
    this.setState({isloading:false})
  }

  onReturn = () => {
    this.props.history.push(`/clients/details/${this.props.match.params.id}/businesses`)
  }

  onEditForm = (section, data) => {
    const {forms} = this.state
    let temp = {...forms}
    temp[section]={...temp[section],...data}
    this.setState({forms:{...temp}})
  }


  onAddBusiness = async(data, type) => {
    try {
      this.onEditForm(type,{issending:true})
      const redata = {...data, client_id:parseInt(this.props.match.params.id)}
      let id = await request_add_business(redata)
      //this.setState({prospect:{...response}})
      this.onEditForm(type,{issending:false, error:null})
      //this.onReturn()
      this.props.history.push(`/clients/details/${this.props.match.params.id}/businesses/${id}`)
      //this.onActivateSuccessSnack()
      //await sleep(2000)
      //this.props.history.goBack()
    } catch (error) {
      this.onEditForm(type,{issending:false})
      if(error.response){
        this.onEditForm(type,{error:error.response.data.error.message, error_details:error.response.data.error.details})
      }
    }
  }

  render(){

    const {history, language, catalogs} = this.props;
    const {isloading, forms, success, users} = this.state
    const content = contentData[language]

    
    return(
      <BasicView
        history={history}
        selected={0}
        onChange={this.onChangeView}
        content={content.layout}
        returnBtn={true}
        onReturn={this.onReturn}
        success={success}
        onCloseSnackbar={this.onCloseSnackbar}
        isloading={isloading}
      >
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <FormA
              catalogs={catalogs}
              catalog_matrix={prospectmatrix}
              form_data={prospectdata}
              error_details={forms.prospectinfo.error_details}
              content={prospectcontent[language]}
              users={users}
              issending={forms.prospectinfo.issending}
              error={forms.prospectinfo.error}
              onDeleteError={this.onDeleteError}
              onSubmit={(data) => this.onAddBusiness(data, 'prospectinfo')}
            />
          </Grid>
        </Grid>
      </BasicView>
      
    )
  }

  onDeleteError = (id) => {
    const {forms} = this.state
    let temp = JSON.parse(JSON.stringify(forms))
    temp.prospectinfo.error = null
    delete temp.prospectinfo.error_details[id]
    this.setState({forms:temp})
  }
}

export default withStyles(styles)(AddBusiness)